import { Check } from "lucide-react";

const PDF_IMAGE = "https://customer-assets.emergentagent.com/job_five-min-formula/artifacts/zt4rrk4l_Formula.png";

const inside = [
  "Reconnect with your creative spark",
  "Release self-doubt and creative blocks",
  "Reignite inspiration and motivation",
  "Take aligned action with clarity and joy",
];

export default function WorksheetPreview() {
  const goToSignup = () => {
    const el = document.getElementById("signup");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      id="worksheet"
      data-testid="worksheet-preview"
      className="bg-[#FFFFFF] border-b border-[#E5E0D8]"
    >
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-24 md:py-32">
        <div className="grid grid-cols-12 gap-10 md:gap-16 items-center">
          {/* Left: editorial description */}
          <div className="col-span-12 md:col-span-5" data-reveal>
            <div className="text-[11px] uppercase tracking-[0.28em] text-[#1FA5B8] font-body">
              What you will receive
            </div>
            <h2 className="mt-4 font-display text-[#1A1A1A] leading-[1.02] tracking-tight text-[clamp(2.25rem,4.6vw,3.75rem)] font-medium">
              The first{" "}
              <span className="italic font-light">doorway</span> in your
              hands.
            </h2>
            <p className="mt-6 font-body text-[#1A1A1A] text-lg leading-[1.75] max-w-md">
              A gentle PDF worksheet. Small enough to keep, honest enough to
              return to. Designed to be opened in five quiet minutes,
              wherever you are.
            </p>

            <ul className="mt-10 space-y-4">
              {inside.map((item, i) => (
                <li
                  key={i}
                  data-testid={`worksheet-benefit-${i + 1}`}
                  className="flex items-start gap-4 border-t border-[#1A1A1A]/10 pt-4"
                >
                  <span className="flex-shrink-0 mt-1 h-6 w-6 rounded-full bg-[#1FA5B8]/10 flex items-center justify-center">
                    <Check size={13} strokeWidth={2} className="text-[#1FA5B8]" />
                  </span>
                  <span className="font-display text-[#1A1A1A] text-[19px] leading-snug tracking-tight">
                    {item}
                  </span>
                </li>
              ))}
            </ul>

            <button
              type="button"
              onClick={goToSignup}
              data-testid="worksheet-cta"
              className="mt-10 inline-flex items-center gap-3 bg-[#1FA5B8] hover:bg-[#178391] text-[#F7F5F2] font-body text-[12px] uppercase tracking-[0.22em] h-12 px-6 transition-colors"
            >
              Receive the worksheet
            </button>
            <p className="mt-3 font-body text-xs text-[#5C5C5C]">
              Free. Sent to your inbox in the next minute.
            </p>
          </div>

          {/* Right: PDF cover, framed editorially */}
          <div className="col-span-12 md:col-span-7" data-reveal>
            <div className="relative">
              {/* Soft backdrop circle */}
              <div
                aria-hidden="true"
                className="absolute inset-x-6 inset-y-12 bg-[#F7F5F2] -z-0"
                style={{ transform: "rotate(-1.5deg)" }}
              />

              {/* Image frame */}
              <div className="relative bg-[#FFFFFF] border border-[#E5E0D8] p-4 md:p-5 shadow-[0_18px_40px_-20px_rgba(26,26,26,0.18)]">
                <img
                  src={PDF_IMAGE}
                  alt="The 5 Minute Creative Reactivation Formula — free PDF worksheet"
                  className="w-full h-auto block"
                  data-testid="worksheet-image"
                />
              </div>

              {/* Small caption strip below */}
              <div className="mt-5 flex flex-wrap items-center justify-between gap-3 px-1 font-body text-[11px] uppercase tracking-[0.28em] text-[#5C5C5C]">
                <span data-testid="worksheet-tag-pdf">PDF Worksheet</span>
                <span data-testid="worksheet-tag-pages">~5 minutes to begin</span>
                <span data-testid="worksheet-tag-free">Yours to keep</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
